// extracted by mini-css-extract-plugin
export default {"modalcontainer":"WelcomeModal_modalcontainer__pFJrF","modalbox":"WelcomeModal_modalbox__uoqVC","header":"WelcomeModal_header__xNh6w"};